import ButtonSync from './ButtonSync';

export default ButtonSync;
